module.exports = __webpack_public_path__ + "static/media/p12.7be9f5c4.jpeg";